import { useForm, getFormProps } from "@conform-to/react"
import { getZodConstraint, parseWithZod } from "@conform-to/zod"
import { useFetcher } from "react-router"
import { z } from "zod"
import { AnalyticsEvents } from "#app/utils/analytics"
import { useIsPending } from "#app/utils/misc"
import { useUmami } from "#app/utils/umami"
import Loader from "../loader"
import { Button } from "../ui/button"
import {
	Form,
	FormContext,
	FormControl,
	FormErrorList,
	FormField,
	FormLabel,
	FormMessage,
} from "../ui/forms/conform-integrated/form"
import { Input } from "../ui/forms/conform-integrated/input"
import { Textarea } from "../ui/textarea"
import { TypographyH1 } from "../ui/typography"

export const ContactFormSchema = z.object({
	name: z.string({
		required_error: "Se requiere un nombre",
	}),
	email: z
		.string({
			required_error: "Se requiere un correo electrónico",
		})
		.email("Correo electrónico no válido."),
	subject: z.string({
		required_error: "Se requiere un asunto.",
	}),
	message: z.string({
		required_error: "Se requiere un mensaje.",
	}),
})

export const contactFormResolver = ContactFormSchema

export default function ContactForm() {
	const isPending = useIsPending()
	const fetcher = useFetcher()
	const { umami } = useUmami()
	const [form, fields] = useForm({
		constraint: getZodConstraint(ContactFormSchema),
		lastResult: fetcher.data?.result,
		onValidate({ formData }) {
			return parseWithZod(formData, { schema: ContactFormSchema })
		},
		shouldRevalidate: "onBlur",
	})

	return (
		<FormContext context={form.context}>
			<Form
				method="POST"
				{...getFormProps(form)}
				className="relative flex flex-1 flex-col gap-4"
				onSubmit={() => {
					umami().track(AnalyticsEvents.CONTACT_FORM_SUBMIT)
				}}
			>
				{isPending && <Loader />}
				<div className="mb-6">
					<TypographyH1>Contacto</TypographyH1>
				</div>

				<div className="flex w-full flex-col gap-y-2">
					<FormField field={fields.name}>
						<div className="flex flex-col gap-2">
							<FormLabel>Nombre</FormLabel>
							<FormControl>
								<Input meta={fields.name} placeholder="Panic" />
							</FormControl>
							<FormMessage />
						</div>
					</FormField>
					<FormField field={fields.email}>
						<div className="flex flex-col gap-2">
							<FormLabel>Correo electrónico</FormLabel>
							<FormControl>
								<Input meta={fields.email} placeholder="panic@thedis.co" />
							</FormControl>
							<FormMessage />
						</div>
					</FormField>
					<FormField field={fields.subject}>
						<div className="flex flex-col gap-2">
							<FormLabel>Asunto</FormLabel>
							<FormControl>
								<Input meta={fields.subject} placeholder="Asunto" />
							</FormControl>
							<FormMessage />
						</div>
					</FormField>
					<FormField field={fields.message}>
						<div className="flex flex-col gap-2">
							<FormLabel>Mensaje</FormLabel>
							<FormControl>
								<Textarea
									meta={fields.message}
									rows={6}
									placeholder="Mensaje"
								/>
							</FormControl>
							<FormMessage />
						</div>
					</FormField>
				</div>

				<FormErrorList formId={form.id} />

				<div className="flex items-center justify-between">
					<Button disabled={isPending} type="submit" className="mt-4 w-fit">
						Enviar
					</Button>
				</div>
			</Form>
		</FormContext>
	)
}
